// Public event names. `tola:*` is the supported surface; the legacy
// `chatwoot:*` name is dispatched alongside it so sites installed before the
// rename keep working. Remove the legacy names only once no customer site
// listens for them.
export const TOLA_ERROR = 'tola:error';
export const TOLA_ON_MESSAGE = 'tola:on-message';
export const TOLA_ON_START_CONVERSATION = 'tola:on-start-conversation';
export const TOLA_POSTBACK = 'tola:postback';
export const TOLA_READY = 'tola:ready';
export const TOLA_OPENED = 'tola:opened';
export const TOLA_CLOSED = 'tola:closed';

export const LEGACY_EVENT_NAMES = {
  [TOLA_ERROR]: 'chatwoot:error',
  [TOLA_ON_MESSAGE]: 'chatwoot:on-message',
  [TOLA_ON_START_CONVERSATION]: 'chatwoot:on-start-conversation',
  [TOLA_POSTBACK]: 'chatwoot:postback',
  [TOLA_READY]: 'chatwoot:ready',
  [TOLA_OPENED]: 'chatwoot:opened',
  [TOLA_CLOSED]: 'chatwoot:closed',
};

// Aliases so existing imports keep resolving.
export const CHATWOOT_ERROR = TOLA_ERROR;
export const CHATWOOT_ON_MESSAGE = TOLA_ON_MESSAGE;
export const CHATWOOT_ON_START_CONVERSATION = TOLA_ON_START_CONVERSATION;
export const CHATWOOT_POSTBACK = TOLA_POSTBACK;
export const CHATWOOT_READY = TOLA_READY;
export const CHATWOOT_OPENED = TOLA_OPENED;
export const CHATWOOT_CLOSED = TOLA_CLOSED;
